import { type BlockedRecordBlockedType } from '@exam-center/graphql';
import { dayjs } from '@shared/utils';

import { COOL_DOWN_PERIOD_BY_BLOCKED_TYPE } from './constants';

export function calculateBlockedDuration(startDate: Date, endDate: Date) {
  const start = dayjs(startDate);
  const end = dayjs(endDate);

  const years = end.diff(start, 'year');
  const months = end.diff(start.add(years, 'year'), 'month');
  const days = end.diff(start.add(years, 'year').add(months, 'month'), 'day');

  const parts = [];
  if (years) parts.push(`${years} ปี`);
  if (months) parts.push(`${months} เดือน`);
  if (days || parts.length === 0) parts.push(`${days} วัน`);

  return parts.join(' ');
}

export function calculateEnforcementEndDate(input: {
  blockedAt?: Date | null;
  enforcementEndDuration?: number | 'custom' | null;
  enforcementEndDate?: Date | null;
}) {
  const { blockedAt, enforcementEndDuration, enforcementEndDate } = input;

  let calculatedEnforcementEndDate: Date | null = null;

  if (enforcementEndDuration === 'custom' && enforcementEndDate) {
    calculatedEnforcementEndDate = enforcementEndDate;
  } else if (typeof enforcementEndDuration === 'number') {
    calculatedEnforcementEndDate = dayjs(blockedAt).add(enforcementEndDuration, 'days').toDate();
  }

  return calculatedEnforcementEndDate;
}

export function calculateBlockedUntilDate(input: {
  blockedType?: BlockedRecordBlockedType | null;
  enforcementEndDate?: Date | null;
}) {
  const { blockedType, enforcementEndDate } = input;

  let blockedUntil: Date | null = null;

  if (enforcementEndDate && blockedType) {
    const coolDownPeriodByBlockedType = COOL_DOWN_PERIOD_BY_BLOCKED_TYPE[blockedType];
    blockedUntil = dayjs(enforcementEndDate)
      .add(coolDownPeriodByBlockedType, 'days')
      .endOf('day')
      .toDate();
  }

  return blockedUntil;
}
